import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { langList } from './langList.mjs'

export { langList }

const localeModules = import.meta.glob('./locales/*.json', { eager: true, import: 'default' }) as Record<string, object>

const resources = Object.entries(localeModules).reduce((acc, [path, translation]) => {
  const lang = path.match(/([^/]+)\.json$/)?.[1]
  if (lang) acc[lang] = { translation }
  return acc
}, {} as Record<string, { translation: object }>)

const RTL_LANGS = ['ar', 'he', 'fa', 'ur'] as const
export const isRtl = (lng: string) => {
  const base = lng.slice(0, 2) as (typeof RTL_LANGS)[number]
  return RTL_LANGS.includes(base)
}

i18n
  .use(initReactI18next)
  .init({
    resources: resources,
    fallbackLng: 'en',
    lng: navigator.language,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })
  .catch((error) => {
    console.error('i18n initialization failed:', error)
  })

// Apply once on startup for the initial language
try {
  const initial = (i18n.language || navigator.language || 'en').slice(0, 2)
  document.documentElement.lang = initial
  document.documentElement.dir = isRtl(initial) ? 'rtl' : 'ltr'
}
catch {} // no-op if document is unavailable (SSR)

export default i18n
